import React from 'react';
import { paths } from 'client/shared/Paths';
import { Footer } from 'components/Footer';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
import { DMCA } from './components/DMCA';
import { CCPA } from './components/CCPA';

function getPageContent(pathname) {
  switch (pathname) {
    case paths.legal.privacy:
      return <PrivacyPolicy pathname={pathname} />;
    case paths.legal.dmca:
      return <DMCA pathname={pathname} />;
    case paths.legal.ccpa:
      return <CCPA pathname={pathname} />;
    case paths.legal.tos:
    default:
      return <TermsOfService pathname={pathname} />;
  }
}

export function TermsScreen({ location: { pathname } }) {
  return (
    <>
      {getPageContent(pathname)}
      <Footer />
    </>
  );
}
